import React from 'react';
import { useHistory } from 'react-router';
import YassImg from '../../assets/error404.svg';

import './SuccessOnboard.css';

const SuccessOnboard = () => {
  const history = useHistory();
  function goToHomePage() {
    history.push('/home');
  }
  function goToLogin() {
    history.push('/login');
  }

  return (
    <section className="success-container">
      <div className="success-info">
        <h2>Yass!</h2>
        <h3>Now lets personalize your experience</h3>
        <p>
          We want to help you with your haelo experience by suggesting
          celebrities, brands, influencers and other fans that has similar
          interests with you.
        </p>
        <div className="success-buttons">
          <button
            type="button"
            className="btn btn--outline support-error"
            onClick={goToHomePage}
          >
            Not Yet
          </button>
          <button
            type="button"
            className="btn btn--primary back_home"
            onClick={goToLogin}
          >
            Continue to Login
          </button>
        </div>
      </div>

      <div className="success-img">
        <img src={YassImg} alt="Haelo success page" className="hero__image" />
      </div>
    </section>
  );
};

export default SuccessOnboard;
